import appConfig from "./appConfig";
import appConfigFeatures from "./appConfigFeatures";
import intermediateAuth from "./intermediateAuth";
import invitations from "./invitations";
import userAccount from "./userAccount";
const app = {
    invitations,
    appConfig,
    appConfigFeatures,
    userAccount,
    intermediateAuth,
};
export default app;
